/**
 * `SHELL-042`/`A11Y-044`: restarting discards the current attempt's progress
 * (score, moves, goal progress -- everything but the level itself), and
 * `A11Y-044` requires a destructive action to name what it loses before it
 * happens. `ConfirmDialog` (Sprint 5c stage 1) is the same trap
 * `LeaveConfirmDialog` uses; this file is the restart-specific copy.
 */

import { ConfirmDialog } from '@shell/ConfirmDialog';

export interface RestartConfirmDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export function RestartConfirmDialog({ onCancel, onConfirm }: RestartConfirmDialogProps) {
  return (
    <ConfirmDialog
      headingId="restart-confirm-heading"
      detailId="restart-confirm-detail"
      heading="Restart this level?"
      detail="Your current score, moves and progress toward its goals will be lost."
      cancelLabel="Cancel"
      confirmLabel="Restart"
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
